import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { gspx } from '@rsos/gainsight';
import SectionGate from '../../../app/SectionGate';
import { initialize } from './appSlice';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }

      gspx.identify();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

// Init gate for the communication section. Acts as a route layout: the section's
// sub-routes (messaging, the deprecated text-from-911 redirect) and the
// `/admin/*` catch-all live in the consolidated route table (app/Main.tsx),
// which is also where each of those routes' access is enforced.
const App = () => {
  const dispatch = useDispatch();
  const { initialized, initializing, initError } = useSelector(
    state => state.communication,
  );
  useInitialize(dispatch);

  return (
    <SectionGate
      initializing={initializing}
      initialized={initialized}
      hasError={!!initError}
    />
  );
};

export default App;
